module.exports = __webpack_public_path__ + "er.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/er.svg
// module id = 791
// module chunks = 0